import { inject, Injectable, OnDestroy, Signal, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, of, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';

interface MeResponse {
  data: {
    is_admin: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class TokenService implements OnDestroy {
  private http: HttpClient = inject(HttpClient);

  private _token = signal<string | null>(null);
  private _isAdmin = signal<boolean>(false);

  readonly token = this._token.asReadonly();
  readonly isAdmin = this._isAdmin.asReadonly();

  private messageListener: ((event: MessageEvent) => void) | null = null;
  private validateTokenSubscription: Subscription | undefined;
  initFromQueryParam(tokenParam: string | null): void {
    if (tokenParam) {
      this._token.set(tokenParam);
      this.validateToken(tokenParam);
    }
  }

  private validateToken(token: string): void {
    this.validateTokenSubscription = this.http
      .get<MeResponse>(`${environment.KINOMAP_API_URL}/me?appToken=${environment.API_APP_TOKEN}`, {
        headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
      })
      .pipe(catchError(() => of(null)))
      .subscribe((response: MeResponse | null) => {
        const admin: boolean = response?.data?.is_admin === true;
        this._isAdmin.set(admin);
        if (!environment.production) {
          console.log('[TokenService] Réponse /me brute:', response);
          console.log('[TokenService] Validation token:', admin ? 'admin' : 'non-admin');
        }
      });
  }

  listenPostMessage(): void {
    const allowedOrigin: string = new URL(environment.KINOMAP_ADMIN_URL).origin;

    this.messageListener = (event: MessageEvent) => {
      const isAllowedOrigin: boolean =
        event.origin === allowedOrigin ||
        (!environment.production && /^https?:\/\/localhost(:\d+)?$/.test(event.origin));

      if (!isAllowedOrigin) {
        return;
      }
      if (event.data?.type === 'KINOMAP_TOKEN' && event.data?.token) {
        this._token.set(event.data.token);
        this.validateToken(event.data.token);
      }
    };
    window.addEventListener('message', this.messageListener);
  }

  ngOnDestroy(): void {
    if (this.messageListener) window.removeEventListener('message', this.messageListener);
    if (this.validateTokenSubscription) this.validateTokenSubscription.unsubscribe();
  }
}
